import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

export const Container = styled(Box)(({ theme }) => ({
  margin: '2rem 8rem',
  [theme.breakpoints.down('lg')]: {
    margin: '1rem 4rem',
  },
  [theme.breakpoints.down('md')]: {
    textAlign: 'center',
    margin: '1rem 2rem',
    ['& .contentblock-content']: {
      textAlign: 'left',
      marginTop: '16px',
    },
  },
  [theme.breakpoints.up('xl')]: {
    width: '1300px',
    marginInline: 'auto !important',
  },
}));

/**
 * Matches the header container (1366px centered) and its logo gutters,
 * so the content starts on the same vertical line as the site logo.
 * Below 1025px the mobile header takes over, which uses a 2rem gutter.
 */
export const LogoAlignedContainer = styled(Container)(({ theme }) => ({
  [theme.breakpoints.down(1025)]: {
    marginInline: '2rem !important',
  },
  [theme.breakpoints.down('md')]: {
    // '&&' outranks the centered text rule inherited from Container
    ['&&']: {
      textAlign: 'left',
    },
  },
  [theme.breakpoints.up(1025)]: {
    width: '100% !important',
    maxWidth: '1366px',
    marginInline: 'auto !important',
    paddingLeft: '6rem',
    paddingRight: '5rem',
  },
  [theme.breakpoints.between(1025, 1150)]: {
    paddingLeft: '4rem',
    paddingRight: '3rem',
  },
}));
